import Component from '../core/Component'
import Cookies from 'js-cookie'

export default class FixedPromo extends Component {
    constructor(element, options) {
        super(element, options)
        
        this.ref = {
            close: null
        }
    }

    prepare() {
        const isCompact = Cookies.get(`fixedpromo`) === 'compact'

        this.ref.close.addEventListener('click', this.handleCloseClick)

        if (isCompact) {
            this.element.classList.add('is-compact')
        } else {
            this.element.classList.add('is-full')
        }
    }

    handleCloseClick = () => {
        this.close()
    }


    close() {
        this.element.classList.remove('is-full')
        this.element.classList.add('is-compact')
        
        Cookies.set('fixedpromo', 'compact', {
            expires: 1
        })
    }
}